import { Wordcut } from './wordcut'
import { cut } from './wordcut_core'

interface IOptions {
    /**
     * The string to use at the beginning of each line.
     * @default ´´ (none)
     */
    indent?: string
}

const wrapText = (arrWordCut: string[], length: number) => {
    let arrResult: string[] = []
    let newText: string = ''
    arrWordCut.forEach((word: string, index: number) => {
        if (index === 0) {
            // first word
            newText = word
        } else if (index === arrWordCut.length - 1) {
            // last word
            if (newText.length + word.length <= length) {
                newText += word
            }
            arrResult.push(newText)
        } else {
            if (newText.length + word.length <= length) {
                newText += word
            } else {
                arrResult.push(newText)
                newText = word
            }
        }
    })

    return arrResult
}

export const thaiWordWrap = (word: string, length: number, newlineSymbol: string, options?: IOptions) => {
    options = options || {}
    if (word === null) {
        return word
    }

    word = word.trim()
    let arrResult: string[] = []
    if (length >= word.length) {
        arrResult.push(word)
    } else {
        Wordcut.init()
        let wordingCut: string = cut(word)

        let arrWordCut: string[] = wordingCut.split('|')
        if (arrWordCut.length > 0) {
            arrResult = wrapText(arrWordCut, length)
        }
    }

    var result = arrResult.join(newlineSymbol)

    return result
}
